<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button
                    type="button"
                    class="close"
                    @click="$emit('close-partecipants-modal')"
            >
                <i class="las la-times"></i>
            </button>
            <h4 style="text-transform: capitalize;" class="modal-title">
                {{ getLongDateFromISO(appointmentDetail.date) }}
            </h4>
        </template>
        <template v-slot:body>
            <h2>
                {{
                    $t("components.appointment.title_tiny", {
                        rate_name: appointmentDetail.rate_name,
                        chaired_admin_name: appointmentDetail.chaired_admin_name
                    })
                }}
            </h2>
            <p>
                {{
                    $t("components.appointment.people_reserved", {
                        reservation_count: appointmentDetail.reservation_count,
                        max_participant: appointmentDetail.max_participant
                    })
                }}
            </p>
            <table
                    v-if="appointmentDetail.reservations_active.length !== 0"
                    class="table"
            >
                <tbody>
                <tr
                        v-for="reservation in appointmentDetail.reservations_active"
                        v-bind:key="reservation.id"
                >
                    <td>
                        <div class="row">
                            <div class="col-xs-12 col-md-6">
                                <router-link :to="{ name: 'client_detail', params: { id: reservation.client.id }}" target="_blank">
                                    {{ reservation.client.first_name }}
                                    {{ reservation.client.last_name }} <br/>
                                </router-link>
                            </div>
                        </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </template>
    </ModalContainer>
</template>

<script>
import {
    cancelAppointment,
    cancelReservation,
    getAppointmentDetail,
    getJoinMeetingUrl,
    noShowClientAppointment,
    showClientAppointment
} from "../../api";
import {Utils} from "../../common/utils";
import ModalContainer from "./ModalContainer";

export default {
    name: "PartecipantsListModal",
    components: {ModalContainer},
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        appointmentId: {
            type: Number,
            required: true
        }
    },
    data: () => {
        return {
            loading: false,
            errorMessage: "",
            appointmentDetail: {
                reservations_active: []
            }
        };
    },
    watch: {
        async appointmentId(newVal) {
            this.loading = true;
            try {
                this.appointmentDetail = await getAppointmentDetail(newVal);
                this.loading = false;
            } catch (e) {
                console.log(e);
                this.loading = false;
            }
        }
    },
    methods: {
        getLongDateFromISO(date) {
            return Utils.getLongDateFromISO(date);
        },
        async showClientAppointmentClick(client_id, appointment_id) {
            this.loading = true;
            try {
                await showClientAppointment(client_id, appointment_id);
                this.appointmentDetail = await getAppointmentDetail(this.appointmentId);
                this.loading = false;
            } catch (e) {
                console.log(e);
                this.loading = false;
            }
        },
        async cancelReservationClick(reservation_id) {
            this.loading = true;
            try {
                await cancelReservation(reservation_id);
                this.appointmentDetail = await getAppointmentDetail(this.appointmentId);
                this.loading = false;
            } catch (e) {
                console.log(e);
                this.loading = false;
            }
        },
        async getJoinMeetingUrl(reservation_id) {
            this.loading = true;
            try {
                let joinMeetingUrl = await getJoinMeetingUrl(
                        this.appointmentId,
                        reservation_id
                );
                window.open(joinMeetingUrl, "_blank");
                this.loading = false;
            } catch (e) {
                console.log(e);
                this.loading = false;
            }
        },
        startLessonClick() {
            if (this.appointmentDetail.meeting_start_url) {
                window.open(this.appointmentDetail.meeting_start_url, "_blank");
            } else if (this.appointmentDetail.zoom_start_url) {
                window.open(this.appointmentDetail.zoom_start_url, "_blank");
            }
        },
        async cancelAppointmentClick() {
            //TODO add success message and confirm
            this.loading = true;
            try {
                await cancelAppointment(this.appointmentDetail.id);
                this.loading = false;
                this.$emit("close-partecipants-modal");
            } catch (e) {
                console.log(e);
                this.loading = false;
            }
        },
        async noShowClientAppointmentClick(client_id, appointment_id) {
            //TODO add success message and confirm
            this.loading = true;
            try {
                await noShowClientAppointment(client_id, appointment_id);
                this.appointmentDetail = await getAppointmentDetail(this.appointmentId);
                this.loading = false;
            } catch (e) {
                console.log(e);
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped></style>
